export function convertSvgImageToPng(htmlImageElement: HTMLImageElement) {
    var canvas = document.createElement('canvas')
    canvas.width = htmlImageElement.naturalWidth
    canvas.height = htmlImageElement.naturalHeight
    var ctx = canvas.getContext('2d')

    if (ctx) {
        ctx.fillStyle = '#FFFFFF' // Add bg color
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(
            htmlImageElement,
            20,
            20,
            htmlImageElement.width - 40,
            htmlImageElement.height - 40,
        )
        return canvas.toDataURL('image/png')
    } else return null
}

export async function convertSvgToPngAsync(
    svgDataUrl: string,
    padding: number = 20,
) {
    return new Promise<string>((resolve) => {
        var img = new Image()
        img.src = svgDataUrl
        img.onload = function () {
            var canvas = document.createElement('canvas')
            var context = canvas.getContext('2d')
            canvas.width = img.naturalWidth
            canvas.height = img.naturalHeight
            context!.fillStyle = '#FFFFFF' // Add bg color
            context!.fillRect(0, 0, canvas.width, canvas.height)
            context!.drawImage(
                img,
                padding,
                padding,
                img.width - padding * 2,
                img.height - padding * 2,
            )
            resolve(canvas.toDataURL('image/png', 1))
        }
    })
}
